export default __webpack_public_path__ + "static/media/restyling-kits.562d2e21.jpg";